import { useTranslateItem } from 'src/hooks/directus/useTranslateItem';
import { DictionaryCode } from 'src/models/pim/dictionaries';
import { useDictionaryDetailsQuery } from 'src/modules/products/hooks/useDictionaryDetailsQuery';

export const useDictionary = (code: DictionaryCode) => {
  const translateFn = useTranslateItem();

  const { data: dictionary } = useDictionaryDetailsQuery(code);

  return dictionary?.entries.map(translateFn) ?? [];
};
